const ANCHOR_TAG = /<a\b[^>]*>/gi
const HREF_ATTRIBUTE = /\shref\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i
const BLANK_TARGET = /\s+target\s*=\s*(?:"_blank"|'_blank'|_blank(?=[\s>]))/i
const REL_ATTRIBUTE = /\s+rel\s*=\s*(?:"([^"]*)"|'([^']*)')/i
const NEW_TAB_RELS = ['noopener', 'noreferrer']
const CONTENT_HOST = 'agmvision.com'

const hostOf = url => {
  const match = String(url || '').match(/^https?:\/\/([^/?#:]+)/i)
  return match ? match[1].toLowerCase().replace(/^www\./, '') : null
}

const isInternal = (href, siteHosts) => {
  if (!href) return false
  if (href.startsWith('/')) return !href.startsWith('//')
  return siteHosts.includes(hostOf(href))
}

const withoutNewTabRels = tag =>
  tag.replace(REL_ATTRIBUTE, (match, doubleQuoted, singleQuoted) => {
    const kept = (doubleQuoted ?? singleQuoted)
      .split(/\s+/)
      .filter(token => token && !NEW_TAB_RELS.includes(token.toLowerCase()))
    return kept.length ? ` rel="${kept.join(' ')}"` : ''
  })

export const withInternalLinksInSameTab = (html, siteUrl) => {
  if (!html || !html.includes('<a')) {
    return html
  }

  const siteHosts = [CONTENT_HOST, hostOf(siteUrl)].filter(Boolean)

  return html.replace(ANCHOR_TAG, tag => {
    const href = tag.match(HREF_ATTRIBUTE)
    const value = href ? href[1] ?? href[2] ?? href[3] : null

    if (!isInternal(value, siteHosts) || !BLANK_TARGET.test(tag)) {
      return tag
    }

    return withoutNewTabRels(tag.replace(BLANK_TARGET, ''))
  })
}
